<template>
  <div class="member p_depart_member">
    <div class="memberTop departMemberTop">
      <div style="display:flex">
        <div class="memberInput">
          <ShowNavHead />
        </div>
      </div>
      <div class="flex">
        <div v-if="tableType=='emp'">
          <span class="flname">员工状态：</span>
          <el-select v-model="dataPage.strWorkState" @change="changeWorkStatus(departInfo.strorgancode,role)" style="width:120px">
            <el-option value="在职"></el-option>
            <el-option value="离职"></el-option>
            <!-- <el-option value="冻结"></el-option>
            <el-option value="禁用"></el-option> -->
          </el-select>
          <span class="flname">岗位：</span>
          <el-select v-model="dataPage.strstation" style="width:150px" size="small" placeholder="" clearable>
            <el-option v-for="(item, index) in postData" :key="index + 'b'" :label="item.StationName" :value="item.Stationid"></el-option>
          </el-select>
          <el-input v-model.trim="dataPage.keyword" placeholder="请输入员工姓名、ID或者手机号码" clearable @keyup.enter.native="seachUser" style="width:260px;margin-left:10px"></el-input>
          <el-button type="success" plain size="small" @click="seachUser" style="margin-left:10px">&nbsp;&nbsp;搜索&nbsp;&nbsp;</el-button>
          <button class="search" style="margin:0 0 0 10px" @click="addMember" v-if="checkPermission(['departMember_add_member'],permissionLists)">+增加新成员</button>
          <button v-if="checkPermission(['departMember_member_export'],permissionLists)" class="search" style="margin:0 20px 0 10px" @click="showexportMember = true">成员导出</button>
        </div>
        <button class="search" v-if="tableType!='emp'&&(checkPermission(['departMember_organ_export'],permissionLists))" style="margin-right:20px;" @click="exportOrg()">机构导出</button>
        <!-- <el-dropdown @command="handleCommand">
          <button class="search" style="margin:0 30px 0 30px"  :loading="btnLoading">
            导出<i class="el-icon-arrow-down el-icon--right"></i>
          </button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">导出全部成员</el-dropdown-item >
            <el-dropdown-item command="b">导出全部机构</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
      </div>
    </div>
    <div class="memberComn">
      <div class="departTree" v-loading="treeloading" element-loading-spinner="el-icon-loading">
        <div class="resize-bar"></div>
        <div class="resize-line"></div>
        <div class="resize-save">
          <!-- <div>
            <button class="search" style="margin:0 30px 10px 0px" @click="exportOrg" :loading="btnLoading2">导出机构</button>
          </div> -->
          <el-input placeholder="部门名称模糊查询" v-model="filterText"></el-input>
          <!-- <div class="addLv cp">
          <i class="el-icon-plus" @click="addFirstDepart">新增一级部门</i>
        </div> -->
          <el-tree ref="tree" :filter-node-method="filterNode" :expand-on-click-node="false" :default-expanded-keys="expandedList" :data="treeList" node-key="strorgancode" :indent=Number(8) :current-node-key="currKey" @node-click="handleNodeClick">
            <span class="custom-tree-node" slot-scope="{ node, data }" @mouseenter="mouseenter(data)" @mouseleave="mouseleave(data)">
              <i class="el-icon-warning-outline" v-if="data.strIsDisable=='1'" style="color:#f56c6c;font-size: 16px;" title="该部门已被禁用"></i>
              <el-tooltip class="item" v-if="data.strorganname.length>8" effect="dark" :content="data.strorganname" placement="top-start">
                <span class="level_item"> {{ellip(data.strorganname,8) }} </span>
              </el-tooltip>
              <span class="level_item" v-else> {{data.strorganname }} </span>
              <span class="departTree_btn" v-show="data.show">
                <el-button type="text" v-if="checkPermission(['departMember_add_depart'],permissionLists)" icon="el-icon-plus" @click.stop="() => append(node,data)" title="新增下级部门"></el-button>
                <el-button type="text" icon="el-icon-edit" @click.stop="() => editDepart(node,data)" title="修改部门" v-if="data.strorgancode!='1'&&(checkPermission(['departMember_edit_depart'],permissionLists))"></el-button>
                <el-button type="text" v-if="data.lvid!='0'&&(checkPermission(['departMember_disable_depart'],permissionLists))" :icon="data.strIsDisable == '1' ? 'el-icon-circle-check' : 'el-icon-circle-close'" @click.stop="() => banDepart(data)" :title="data.strIsDisable == '1' ? '启用部门' : '禁用部门'"></el-button>
                <el-button type="text" v-if="!data.children" icon="el-icon-delete" slot="reference" @click.stop="() => deleteDepart(data)" title="删除部门"></el-button>
              </span>
            </span>
          </el-tree>
        </div>
      </div>
      <div class="memberTable">
        <div class="crumbs">
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane v-for="(item,index) in editableTabs" :key="index+'a'" :label="item.title" :name="item.name">
            </el-tab-pane>
          </el-tabs>
        </div>
        <el-table v-if="tableType=='emp'" :data="tableData" :max-height="tableHeight-220" border style="width: 100%" v-loading="tableLoading" :highlight-current-row="true" element-loading-spinner="el-icon-loading">
          <el-table-column align="center" prop="Strorganname" label="部门" min-width="100px" fit :show-overflow-tooltip="true" fixed>
          </el-table-column>
          <el-table-column align="center" prop="Username" label="员工姓名" min-width="120px" fixed fit :show-overflow-tooltip="true">
            <template scope="scope">
              <div class="choosename cp" :style="{color: scope.row.isHighlight ? '#fff' : '#19bd92'}" title="查看员工详情" @click="lookMember(scope.row)">{{scope.row.Username}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="UserNumber" label="员工ID" min-width="100px"></el-table-column>
          <el-table-column align="center" prop="Stridcard" label="身份证号码" min-width="160px" fit :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" prop="Strmobile" label="手机号码" min-width="110px" fit :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" prop="Strstationname" label="岗位名称" min-width="100px" fit :show-overflow-tooltip="true"></el-table-column>
          <!-- <el-table-column align="center" prop="StrJobfunclabelname" label="岗位职能标签" min-width="110px"></el-table-column> -->
          <el-table-column align="center" prop="strtopusername" label="上级主管" min-width="100px" fit :show-overflow-tooltip="true"></el-table-column>
          <!-- <el-table-column align="center" prop="StrTimepro" label="时间占比" min-width="100px"></el-table-column> -->
          <el-table-column align="center" prop="DtEntryDate" label="入职时间" min-width="100px" fit :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.DtEntryDate && scope.row.DtEntryDate!='1900-01-01T00:00:00' ? scope.row.DtEntryDate.substring(0, 10): '-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="DtQuitDate" label="离职时间" min-width="100px" fit :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.DtQuitDate && scope.row.DtQuitDate!='1900-01-01T00:00:00' ? scope.row.DtQuitDate.substring(0, 10): '-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrWorkState" label="是否在职" min-width="100px"></el-table-column>
          <el-table-column align="center" prop="StrIspartner" label="是否合伙人" min-width="100px"></el-table-column>
          <el-table-column align="center" fixed="right" label="操作" width="60px">
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  <img src="../../assets/employee/images/more.png" style="width:14px;height:16px;cursor: pointer" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="editMember(scope.row)" v-if="checkPermission(['departMember_edit_member'],permissionLists)">
                    <img src="../../assets/employee/images/edit.png" class="editEmployee" />编辑账号信息
                  </el-dropdown-item>
                  <!-- <el-dropdown-item @click.native="dltMember(scope.row)">
                    <img src="../../assets/employee/images/del.png" class="editEmployee" />删除成员
                  </el-dropdown-item> -->
                  <!-- 只有主账号有权限 -->
                  <el-dropdown-item v-if="checkPermission(['departMember_reset_password'],permissionLists)" @click.native="resetMember(scope.row)" :disabled="!isNull(scope.row.Mainuserid)">
                    <i class="el-icon el-icon-refresh-right" style="display:inline-block;margin-right:12px;"></i>重置密码
                  </el-dropdown-item>
                  <el-dropdown-item v-if="checkPermission(['departMember_edit_state'],permissionLists)" @click.native="frozenMember(scope.row)">
                    <i class="el-icon-lock"></i> 修改员工状态
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="tableType=='emp'">
          <el-pagination @current-change="changeBPage" :current-page.sync="currpage" :page-size="pagecount" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev,pager, next, jumper" :total="total"></el-pagination>
        </div>
        <div v-if="tableType=='depart'" class="departInfo">
          <div class="tag_btn_box" v-if="isHasChildToShow">
            <el-button type="success" size="small" @click="addLabelHandle">设置招聘部门</el-button>
          </div>
          <el-descriptions v-loading="treeloading" element-loading-spinner="el-icon-loading">
            <el-descriptions-item label="部门">{{departInfo.strorganname}}</el-descriptions-item>
            <el-descriptions-item label="负责人">{{departInfo.strLeaderidname && departInfo.strLeaderidname!= '/' ? departInfo.strLeaderidname : '无'}}</el-descriptions-item>
            <el-descriptions-item label="最高负责人">{{departInfo.strtopLeaderidname && departInfo.strtopLeaderidname!= '/' ? departInfo.strtopLeaderidname : '无'}}</el-descriptions-item>
            <el-descriptions-item label="经办人">{{departInfo.strHandleidname && departInfo.strHandleidname!= '/'   ? departInfo.strHandleidname: '无'}}</el-descriptions-item>
            <el-descriptions-item label="是否合伙人业务团队">{{departInfo.strParIsbusiteam}}</el-descriptions-item>
            <el-descriptions-item label="合伙人">{{departInfo.strPartnername && departInfo.strPartnername!= '/' ? departInfo.strPartnername : '无'}}</el-descriptions-item>
            <el-descriptions-item label="是否业务团队">{{departInfo.strIsbusiteam}}</el-descriptions-item>
            <el-descriptions-item label="是否招聘团队">{{departInfo.strIsRecteam}}</el-descriptions-item>
            <el-descriptions-item label="是否客服团队">{{departInfo.strIsCustomerteam}}</el-descriptions-item>
            <el-descriptions-item label="成本挂靠人员">{{departInfo.strAffbusicostname}}</el-descriptions-item>
          </el-descriptions>
          <!-- 部门标签列表 -->
          <div class="dep_label_box">
            <el-table ref="labelTable" class="com_table tag_table_box" border v-loading="depTableLoading" :highlight-current-row="true" :data="depTableData" style="width:100%">
              <el-table-column label="部门名称" fixed="left" fit :show-overflow-tooltip="true" min-width="110px" align="center">
                <template slot-scope="{row}">
                  <span>{{row.Strorganname}}</span>
                </template>
              </el-table-column>
              <el-table-column label="标签" fit :show-overflow-tooltip="true" min-width="110px" align="center">
                <template slot-scope="{row}">
                  <span>{{row.StrLabel}}</span>
                </template>
              </el-table-column>
              <el-table-column label="创建时间" fit :show-overflow-tooltip="true" min-width="110px" align="center">
                <template slot-scope="{row}">
                  <span>{{row.DtInsertDate?row.DtInsertDate.replace('T',' '):''}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" fixed="right" width="90px" align="center">
                <template slot-scope="{row}">
                  <el-button type="success" plain size="mini" @click="dltLabelHandle(row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- <div class="block">
              <el-pagination
                @current-change="labelCurrentChange"
                @size-change="labelSizeChange"
                :current-page.sync="labelQuery.currpage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="labelQuery.perpage"
                layout="total,sizes,prev,pager, next, jumper"
                :total="labelTotalcount"
              ></el-pagination>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="dialog-box">
      <!-- 删除成员 -->
      <el-dialog title="删除成员" :visible.sync="dialogVisible" width="384px">
        <div>您正在删除成员：“{{dltMemberTxt}}”，删除后将无法撤回，请确认操作无误。</div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible = false">取消</button>
          <button class="search" @click="deleteHandle" style="margin-left:10px;font-weight:600">确定</button>
        </span>
      </el-dialog>
      <!-- 删除部门 -->
      <el-dialog :title="isdelete ? '删除部门' : '禁用部门'" :visible.sync="visibleDel" width="384px">
        <div>您正在{{isdelete ? '删除' : '禁用'}} 部门：“{{this.info.strorganname}}”，{{isdelete ? '删除后将无法撤回，' : ''}}请确认操作无误</div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="visibleDel = false">取消</button>
          <button class="search" @click="confirmDeleteDepart" style="margin-left:10px;font-weight:600">确定</button>
        </span>
      </el-dialog>
      <!-- 重置密码 -->
      <el-dialog title="重置密码" :visible.sync="visibleDel2" width="384px">
        <div> {{this.info.Username}} 的密码将被重置为 初始密码 ，请确认</div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="visibleDel2 = false">取消</button>
          <button class="search" @click="confirmResetMember" style="margin-left:10px;font-weight:600">确定</button>
        </span>
      </el-dialog>
      <el-dialog :title="isadd ? '新建部门' : '编辑部门资料'" :visible.sync="showEditDepart" width="800px" :close-on-click-modal="false">
        <div class="diaform">
          <el-form :model="departForm" :inline="true" :rules="rules" ref="departForm" label-width="140px">
            <el-form-item label="上级部门" prop="strtoporganname">
              <!-- 新建 -->
              <el-input v-model="departForm.strtoporganname" disabled autocomplete="off" size="small" style="width: 220px;" v-if="isadd"></el-input>
              <!-- 编辑 -->
              <el-cascader v-model="dedpartNameList" ref="dep" :props="props" clearable filterable :options="treeList" placeholder="请选择上级部门" @change="handleSectionChange" size="small" style="width: 220px;" v-else></el-cascader>
            </el-form-item>
            <el-form-item label="部门名称" prop="strorganname">
              <el-input v-model="departForm.strorganname" autocomplete="off" size="small" style="width: 220px;"></el-input>
            </el-form-item>
            <el-form-item label="部门负责人" prop="leader">
              <el-select v-model="departForm.strLeaderid" clearable filterable size="small" style="width: 220px;">
                <el-option v-for="(item,index) in userList" :key="index" :label="item.Username" :value="item.Userid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="部门最高负责人">
              <el-select v-model="departForm.strtopLeaderid" clearable filterable size="small" style="width: 220px;">
                <el-option v-for="(item,index) in userList" :key="index" :label="item.Username" :value="item.Userid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="部门经办人">
              <el-select v-model="strHandleidList" clearable filterable size="small" style="width: 220px;" multiple>
                <el-option v-for="(item,index) in userList" :key="index" :label="item.Username" :value="item.Userid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="合伙人">
              <el-select v-model="departForm.strPartner" clearable filterable size="small" style="width: 220px;">
                <el-option v-for="(item,index) in userList" :key="index" :label="item.Username" :value="item.Userid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="成本挂靠人员">
              <el-select v-model="departForm.strAffbusicost" clearable filterable size="small" style="width: 220px;">
                <el-option v-for="(item,index) in userList" :key="index" :label="item.Username" :value="item.Userid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否合伙人业务团队">
              <div class="switchBox">
                <el-switch v-model="departForm.strParIsbusiteam" active-value="是" inactive-value="否"></el-switch>
              </div>
            </el-form-item>

            <el-form-item label="是否业务团队">
              <div class="switchBox">
                <el-switch v-model="departForm.strIsbusiteam" active-value="是" inactive-value="否"></el-switch>
              </div>
            </el-form-item>
            <el-form-item label="是否招聘团队">
              <div class="switchBox">
                <el-switch v-model="departForm.strIsRecteam" active-value="是" inactive-value="否"></el-switch>
              </div>
            </el-form-item>
            <el-form-item label="是否客服团队">
              <div class="switchBox">
                <el-switch v-model="departForm.strIsCustomerteam" active-value="是" inactive-value="否"></el-switch>
              </div>
            </el-form-item>

          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showEditDepart = false" size="small">取 消</el-button>
          <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirm" :loading="isBtnLoading">确认</el-button>
        </span>
      </el-dialog>
      <el-dialog title="修改员工状态" :visible.sync="showfrozenUser" width="400px" :close-on-click-modal="false">
        <div class="frozenform">
          <el-form :model="frozenform" :rules="frozenformrules" ref="frozenform" label-width="95px">
            <el-form-item label="是否在职：" prop="strWorkState">
              <el-select @change="selectChange" v-model="frozenform.strWorkState" placeholder="请选择是否在职">
                <el-option value="在职"></el-option>
                <el-option value="离职"></el-option>
                <!-- <el-option value="冻结"></el-option>
                <el-option value="禁用"></el-option> -->
              </el-select>
            </el-form-item>
            <el-form-item label="离职时间：" v-if="frozenform.strWorkState=='离职'">
              <el-date-picker clearable v-model="frozenform.dtQuitDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择离职时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="入职时间：" v-if="frozenform.strWorkState=='在职'">
              <el-date-picker clearable v-model="frozenform.dtEntryDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择入职时间">
              </el-date-picker>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="showfrozenUser = false">取消</button>
          <button class="search" @click="confirmFrozen" style="margin-left:10px;font-weight:600">确定</button>
        </span>
      </el-dialog>
      <el-dialog title="成员导出" :visible.sync="showexportMember" width="400px" :close-on-click-modal="false">
        <el-form>
          <el-form-item label="员工状态：">
            <el-select v-model="strWorkState" placeholder="请选择状态">
              <el-option value="在职"></el-option>
              <el-option value="离职"></el-option>
              <!-- <el-option value="冻结"></el-option>
                <el-option value="禁用"></el-option> -->
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="showexportMember = false">取消</button>
          <button class="search" @click="exportMember" style="margin-left:10px;font-weight:600">确定</button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import xz from "@/common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    number
  } from "mathjs";
  export default {
    data() {
      var validatDepartename = (rule, value, callback) => {
        if (this.isadd || this.departForm.strorganname != this.oldname) {
          this.checkHandleDepart(res => {
            if (res) {
              callback()
            } else {
              callback(new Error('员工姓名重复'));
            }
          })
        } else {
          callback();
        }
      }
      return {
        memLoading: false,
        treeloading: false,
        tableHeight: 0,
        showexportMember: false,
        roleType: "",
        expandedList: ['1'],
        tableLoading: false,
        //删除成员
        dialogVisible: false,
        isEdit: true,
        editableTabs: [{
          title: '部门信息',
          name: '1',
        }, {
          title: '部门员工信息',
          name: '2'
        }],
        oldname: '', //部门旧名称
        isPhoneRepeat: false,
        // 编辑人员的id
        editUserId: '',
        frozenformrules: {
          'strWorkState': [{
            required: true,
            message: '请选择是否在职',
            trigger: 'change'
          }]
        },
        opUserid: '',
        tableData: [],
        total: 0,
        btnLoading: false,
        btnLoading2: false,
        treeList: [],
        treeList2: [],
        //所有角色
        roles: [],
        //工作岗位列表
        jobList: [],
        roletype: '',
        currpage: 1,
        dataPage: {
          keyword: '',
          strWorkState: '在职',
          strstation: '',
          strorgancode: '',
          currpage: 1,
          perpage: 10
        },
        pagecount: 10,
        //删除成员的名称
        dltMemberTxt: '',
        //输入手机展开内容数据
        searchList: [],
        strWorkState: '在职', //员工导出状态
        frozenform: {
          newuserid: '',
          userTel: '', //手机号
          userName: '', //姓名
          userNumber: '', //员工编号
          strWorkState: '', //在离职
          dtEntryDate: '', //入职时间
          dtQuitDate: '', //离职时间
          userPwd: '', //密码
          Stridcard: '', //身份证
          operation: 'upstatus' // 修改密码 pwd 修改在离职 upstatus
        },
        isPhone: true,
        showfrozenUser: false,
        //显示修改部门
        showEditDepart: false,
        //是否是新增部门
        isadd: false,
        filterText: '',
        tableType: 'depart',
        showEditDepart: false,
        activeName: '1',
        departInfo: {}, //部门信息
        departForm: {
          strorgancode: '', //部门id
          strtoporgancode: '', //上级部门id
          strtoporganname: '',
          lvlid: '', //lv
          orderid: '1',
          strorganname: '', //部门名称
          strLeaderid: '', //负责人
          strtopLeaderid: '', //最高负责人
          strHandleid: '', //经办人
          strParIsbusiteam: '否',
          strPartner: '', //合伙人
          strIsbusiteam: '否',
          strIsRecteam: '否',
          strIsCustomerteam: '否',
          strAffbusicost: '否'
        },
        strHandleidList: [], //选中的济南人
        isdelete: false,
        userList: [],
        topList: [],
        visibleDel: false,
        info: {},
        visibleDel2: false,
        oldHandleid: '', //未改动前的经办人id
        rules: {
          strorganname: [{
              required: true,
              message: '请输入部门名称',
              trigger: 'blur'
            },
            {
              message: '部门名称重复',
              validator: validatDepartename,
              trigger: ['blur']
            }
          ]
        },
        role: '',
        // 修改密码参数
        editPwdQuery: {
          newuserid: '',
          userTel: '', //手机号
          userName: '', //姓名
          userNumber: '', //员工编号
          strWorkState: '', //在离职
          dtEntryDate: '', //入职时间
          dtQuitDate: '', //离职时间
          userPwd: '', //密码
          Stridcard: '', //身份证
          operation: 'pwd' // 修改密码 pwd 修改在离职 upstatus
        },
        // 按钮权限参数
        butQuery: {
          path: '/departMember',
          powerEnName: 'system'
        },
        // 按钮权限
        permissionLists: [],
        // 岗位列表
        postData: [],
        currKey: '1',
        // 选中子节点的所有父节点
        nodeParentAll: [],
        // 部门标签列表
        depTableData: [],
        depTableLoading: false,
        labelTotalcount: 0,
        labelQuery: {
          currpage: 1,
          pagecount: 10,
          strorgancode: ''
        },
        // 分配部门标签参数(新增删除)
        divideDepartQuery: {
          Strorgancode: '',
          StrIsDel: '' //0正常  1删除
        },
        // 部门是否有子级是否有设置过 有的话不显示配置按钮
        isHasChildToShow: false,
        dedpartNameList: [],
        // 自定义 级联选择props
        props: {
          label: 'strorganname',
          value: 'strorgancode',
          children: 'children',
          checkStrictly: true
        },
        isBtnLoading: false,
      };
    },
    created() {
      // console.log('1a', a.toString())
      let that = this
      this.role = localStorage.loginRoletype;
      if (!this.isNull(this.$route.query.active)) { //从新增编辑员工跳转过来
        that.activeName = that.$route.query.active
        that.tableType = 'emp';
        that.dataPage.keyword = '';
      }
      if (!that.isNull(that.$route.query.memGancode)) {
        that.dataPage.strorgancode = that.$route.query.memGancode
        if (that.dataPage.strorgancode == '1') { //杰博股份
          that.dataPage.strorgancode = ''
        }
      } else {
        if (localStorage.gancode == '1') { //杰博股份
          that.dataPage.strorgancode = ''
        } else {
          that.dataPage.strorgancode = localStorage.gancode
        }
      }
      this.getDepartTree('');
      this.getButtonPower()
      this.calHeight();
      this.getTreestr();
      this.getnobandetree();
      // 获取所有人员数据
      this.getAllUserList()
      // 获取岗位列表
      this.getPostList()
      // 部门标签列表
      this.getLabelList()
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        xz.getbtnPowerIdBypage(this.butQuery).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
              // if(that.checkPermission(['departMember_page_list'],that.permissionLists)){
              that.getauthUserInfoByorgancode()
              // }
            } else {
              this.permissionLists = []
            }
          } else {
            this.permissionLists = []
          }
        })
      },
      // 部门标签列表分页
      labelCurrentChange(val) {
        this.labelQuery.currpage = Number(val);
        this.getLabelList();
      },
      labelSizeChange(val) {
        this.labelQuery.currpage = 1;
        this.labelQuery.perpage = Number(val);
        this.getLabelList();
      },
      // 新增标签(设置招聘部门)
      addLabelHandle() {
        let that = this
        that.divideDepartQuery.StrIsDel = '0'
        this.$confirm('是否将该部门设置为招聘部门?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then((res) => {
          that.setLabelDepart()
        })
      },
      // 设置部门标签
      setLabelDepart() {
        let that = this
        xz.bsaveOrganLabel(this.divideDepartQuery).then((res) => {
          if (res.status == 'ok') {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            that.getLabelList();
          } else {
            this.$message({
              type: 'error',
              message: '操作失败'
            })
          }
        });
      },
      // 删除标签
      dltLabelHandle(item) {
        let that = this
        this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then((res) => {
          that.divideDepartQuery.Strorgancode = item.Strorgancode
          that.divideDepartQuery.StrIsDel = '1'
          that.setLabelDepart()
        })
      },
      // 获取部门标签列表
      getLabelList() {
        this.depTableLoading = true;
        xz.getOrganLabel(this.labelQuery).then((res) => {
          if (res.status == 'ok') {
            this.depTableData = res.msg;
            this.labelTotalcount = parseInt(res.totalcount);
          } else {
            this.depTableData = [];
            this.labelTotalcount = 0;
          }
          this.depTableLoading = false;
        });
      },
      // 获取岗位列表
      getPostList() {
        let query = {
          keyword: '', // 角色名称
          perpage: 10000,
          currpage: 1
        }
        xz.bgetStationauthList(query).then(res => {
          // console.log('岗位', res)
          if (res.status == 'ok') {
            this.postData = res.msg
          } else {
            this.postData = []
          }
        })
      },
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
        // console.log('height', this.tableHeight)
      },
      // 获取所有人员列表
      getAllUserList() {
        let dataPage = {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "",
          strstation: "",
          strorgancode: ""
        }
        xz.getauthUserInfoByorgancode(dataPage).then(res => {
          if (res.status == 'ok') {
            this.userList = res.msg;
          } else {
            this.userList = [];
          }
        })
      },
      getnobandetree() {
        let data = {
          strIsDisable: '1'
        }
        xz.getorganstr1('', '', data).then(res => {
          if (res && res.parent.length > 0) {
            this.treeList2 = res.parent;
          }
        })
      },
      //获取岗位职能标签
      getTreestr() {
        let data = {
          currpage: 1,
          perpage: 100,
          strIsDisable: '1',
          keyword: ''
        }
        this.treeLoading = true;
        xz.getTreestr('JB_base_Jobfunclabel', data).then(res => {
          if (res) {
            this.jobFunList = res.msg.parent;
          } else {
            this.jobFunList = [];
          }
        });
      },
      //获取组织架构树形图（tree）
      getDepartTree(code) {
        let that = this
        this.treeloading = true;
        let data = {
          strIsDisable: ''
        }
        xz.getorganstr1('', '', data).then(res => {
          if (res && res.parent.length > 0) {
            this.treeList = res.parent;
            if (code && code != null) {
              this.expandedList = ['1', code]
              this.$nextTick(() => {
                this.$refs.tree.setCurrentKey(code);
              });
            } else {
              if (!that.isNull(that.$route.query.memGancode)) {
                that.currKey = that.dataPage.strorgancode
                that.$nextTick(() => {
                  let checklist = that.$refs.tree.getNode(that.dataPage.strorgancode);
                  // console.log(222,checklist)
                  this.departInfo = checklist.data;
                  that.getParentAll(checklist)
                  that.$refs.tree.setCurrentKey(that.dataPage.strorgancode);
                });
              } else {
                this.departInfo = res.parent[0];
              }
            }
            this.treeloading = false;
          } else {
            this.treeList = [];
            this.treeloading = false;
          }
        })
      },
      // 获取所有父级节点
      getParentAll(node) {
        if (node) {
          this.nodeParentAll = []
          // 节点的第一个父级
          var parentNode = node.parent
          // level为节点的层级 level=1 为顶级节点
          for (let j = 0, lv = node.level; j < lv; j++) {
            if (parentNode.level > 0) {
              // 将所有父级节点放入集合中
              this.nodeParentAll.push(parentNode)
            }
            // 继续获取父级节点的父级节点
            parentNode = parentNode.parent
          }

          if (this.nodeParentAll.length > 1) {
            // 如果集合长度>1 则将数组进行倒叙.reverse() 其是就是将所有节点按照 从 顶级节点 依次往下排
            this.nodeParentAll.reverse()
          }
          if (this.nodeParentAll.length > 0) {
            // 将获取到的所有父级节点进行展开
            for (let i = 0, n = this.nodeParentAll.length; i < n; i++) {
              let elall = this.nodeParentAll[i]
              this.expandedList.push(elall.data.strorgancode)
            }
            this.expandedList.push(this.dataPage.strorgancode)
            this.expandedList = [...new Set(this.expandedList)]
          }
        }
      },
      //树节点名字过长处理
      ellip(value, len) {
        if (!value) return ''
        if (value.length > len) {
          return value.slice(0, len) + '...'
        }
        return value
      },
      //点击树
      handleNodeClick(data, node) {
        // console.log('data',data, node,this.depTableData)
        let that = this;
        let departCode = data.strorgancode;
        // that.labelQuery.strorgancode = data.strorgancode
        // if(that.isNull(node.childNodes)){
        // 判断该部门是否有设置过
        if (!that.isNull(that.depTableData)) {
          if (that.depTableData.some(obj => obj.Strorgancode === departCode)) {
            //对象数组中存在该值
            that.isHasChildToShow = false
          } else {
            //对象数组中不存在该值
            that.isHasChildToShow = true
          }
        } else {
          if (that.isNull(data.children)) {
            that.isHasChildToShow = true
          } else {
            that.isHasChildToShow = false
          }
        }
        that.divideDepartQuery.Strorgancode = data.strorgancode
        that.divideDepartQuery.StrIsDel = '0'
        // }else{
        //   that.isHasChildToShow = false
        // }
        this.departInfo = data;
        if (this.tableType == 'emp') {
          if (this.dataPage.strWorkState == '离职' && data.strorgancode == '1') {
            this.dataPage.strorgancode = ''
            this.getauthUserInfoByorgancode()
          } else {
            if (data.strorgancode == '1') {
              this.dataPage.strorgancode = ''
            } else {
              this.dataPage.strorgancode = data.strorgancode
            }
            this.getauthUserInfoByorgancode()
          }
        }
      },
      seachUser() {
        this.dataPage.currpage = 1;
        if (this.departInfo.strorgancode == '1') {
          this.dataPage.strorgancode = ''
        } else {
          this.dataPage.strorgancode = this.departInfo.strorgancode
        }
        this.getauthUserInfoByorgancode();
      },
      changeWorkStatus(code) {
        this.dataPage.currpage = 1
        if (code == '1') {
          this.dataPage.strorgancode = ''
        } else {
          this.dataPage.strorgancode = code
        }
        this.getauthUserInfoByorgancode()
      },
      //获取部门员工
      getauthUserInfoByorgancode() {
        this.tableLoading = true;
        xz.getauthUserInfoByorgancode(this.dataPage).then(res => {
          if (res.status == 'ok') {
            if (res.totalcount > 0) {
              this.tableData = res.msg;
              this.total = res.totalcount;
            } else {
              this.tableData = [];
              this.total = 0;
            }
            this.tableLoading = false;
          } else {
            this.$message('人员获取出错')
            this.tableData = [];
            this.total = 0;
            this.tableLoading = false;
          }
        })
      },
      //分页
      changeBPage(val) {
        this.dataPage.currpage = Number(val);
        if (this.departInfo.strorgancode == '1') {
          this.dataPage.strorgancode = ''
        } else {
          this.dataPage.strorgancode = this.departInfo.strorgancode
        }
        this.getauthUserInfoByorgancode();
      },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.dataPage.currpage = 1;
        this.dataPage.perpage = Number(val);
        if (this.departInfo.strorgancode == '1') {
          this.dataPage.strorgancode = ''
        } else {
          this.dataPage.strorgancode = this.departInfo.strorgancode
        }
        this.getauthUserInfoByorgancode();
      },
      //校验部门名称
      checkHandleDepart(callback) {
        let chkval = this.departForm.strorganname;
        if (chkval.length > 0) {
          xz.checkJborganname(chkval).then(res => {
            if (res.status == 'ok') {
              callback(true)
            } else {
              callback(false)
            }
          })
        }
      },
      //确定删除成员
      deleteHandle() {},
      //新建员工
      addMember() {
        let that = this
        this.$router.push({
          path: "/updateEmployee",
          query: {
            isEdit: false,
            strorgancode: that.departInfo.strorgancode
          }
        });
        // if (this.$refs['ruleForm'] !== undefined) {
        //   this.$refs['ruleForm'].clearValidate();
        // }
      },
      //冻结成员
      frozenMember(row) {
        // console.log(row)
        this.opUserid = row.Userid;
        this.frozenform.newuserid = row.Userid
        this.frozenform.userTel = row.Strmobile //手机号
        this.frozenform.userName = row.Username //姓名
        this.frozenform.userNumber = row.UserNumber //员工编号
        this.frozenform.strWorkState = row.StrWorkState //在离职
        this.frozenform.dtEntryDate = this.isNull(row.DtEntryDate) ? '' : row.DtEntryDate //入职时间
        this.frozenform.dtQuitDate = this.isNull(row.DtQuitDate) ? '' : row.DtQuitDate //离职时间
        this.frozenform.Stridcard = row.Stridcard //身份证
        this.frozenform.userPwd = ''
        this.showfrozenUser = true;
      },
      //确认修改员工状态
      confirmFrozen() {
        this.$refs['frozenform'].validate((valid) => {
          if (valid) {
            // console.log(111,this.frozenform)
            this.updateUser('upstatus')
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      //查看成员详情
      async lookMember(item) {
        // console.log(item)
        this.$router.push({
          path: "/employeeDtl",
          query: {
            isEdit: 'dtl',
            id: item.Userid,
            mainuserid: item.Mainuserid
          }
        });
      },
      //编辑成员
      async editMember(item) {
        this.$router.push({
          path: "/updateEmployee",
          query: {
            isEdit: true,
            id: item.Userid,
            mainuserid: item.Mainuserid
          }
        });
      },
      //角色标签多选处理
      rolelabelChange(val) {
        console.log(val.toString())
      },
      selectChange() {
        this.$forceUpdate()
      },
      resetMember(item) {
        this.info = item;
        this.editPwdQuery.newuserid = item.Userid
        this.editPwdQuery.userTel = item.Strmobile //手机号
        this.editPwdQuery.userName = item.Username //姓名
        this.editPwdQuery.userNumber = item.UserNumber //员工编号
        this.editPwdQuery.strWorkState = item.StrWorkState //在离职
        this.editPwdQuery.dtEntryDate = item.DtEntryDate //入职时间
        this.editPwdQuery.dtQuitDate = item.DtQuitDate //离职时间
        this.editPwdQuery.Stridcard = item.Stridcard //身份证
        this.visibleDel2 = true;
      },
      //确认重置密码
      confirmResetMember() {
        this.isEdit = false;
        // this.editPwdQuery.userPwd = '88088';
        let idcode = this.editPwdQuery.Stridcard.substring(this.editPwdQuery.Stridcard.length - 6);
        this.editPwdQuery.userPwd = idcode + '##';
        this.updateUser('pwd')
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == ('1900-01-01') || o == '1900-01-01T00:00:00';
      },
      // 重置密码及修改在离职状态
      updateUser(type) {
        let query;
        if (type == 'pwd') {
          this.editPwdQuery.operation = type
          query = this.editPwdQuery
        } else {
          this.frozenform.operation = type
          query = this.frozenform
        }
        // console.log('kk',this.editPwdQuery)
        xz.Resetpwdmodifysta(query).then(res => {
          if (res.status == 'ok') {
            this.$message.success('保存成功');
            if (this.departInfo.strorgancode == '1') {
              this.dataPage.strorgancode = ''
            } else {
              this.dataPage.strorgancode = this.departInfo.strorgancode
            }
            this.getauthUserInfoByorgancode()
            if (type == 'pwd') {
              this.visibleDel2 = false;
            }
            if (type == 'upstatus') {
              this.showfrozenUser = false;
            }
          } else {
            this.$message.error('保存失败');
            if (type == 'pwd') {
              this.visibleDel2 = false;
            }
            if (type == 'upstatus') {
              this.showfrozenUser = false;
            }
          }
        })
      },
      //清空成员
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      //鼠标悬浮
      mouseenter(data) {
        this.$set(data, 'show', true)
      },
      mouseleave(data) {
        this.$set(data, 'show', false)
      },
      //切换表格
      handleClick(tab) {
        if (tab.index == '0') {
          this.tableType = 'depart'
        } else {
          this.tableType = 'emp';
          this.dataPage.keyword = '';
          if (this.departInfo.strorgancode == '1') {
            this.dataPage.strorgancode = ''
          } else {
            this.dataPage.strorgancode = this.departInfo.strorgancode
          }
          this.getauthUserInfoByorgancode()
        }
      },
      //树节点过滤
      filterNode(value, data, node) {
        if (!value) return true;
        let parentNode = node.parent // 父级node
        let labels = [node.data.strorganname] // 当前node的名字
        let level = 1 // 层级
        while (level < node.level) {
          labels = [...labels, parentNode.data.strorganname] // 当前node名字，父级node的名字
          parentNode = parentNode.parent
          level++
        }
        return labels.some(d => d.indexOf(value) !== -1)
        // return data.strorganname.indexOf(value) !== -1;
      },
      //新增一级部门
      addFirstDepart() {
        this.cleardepart();
        this.departForm.lvlid = 1;
        this.showEditDepart = true;
        this.isadd = true;
      },
      //新增部门
      append(node, data) {
        this.cleardepart();
        this.departForm.strtoporgancode = data.strorgancode;
        this.departForm.strtoporganname = data.strorganname;
        this.departForm.lvlid = parseInt(data.lvid) + 1;
        // this.departForm.orderid = Array.isArray(data.children) ? data.children.length : 1
        this.showEditDepart = true;
        this.isadd = true;
        this.info = data;
      },
      //修改部门
      editDepart(node, data) {
        console.log(node, data, this.departForm);
        this.departForm.strorgancode = data.strorgancode;
        this.departForm.strorganname = data.strorganname;
        data.lvid == '0' ? this.departForm.strtoporganname = '' : this.departForm.strtoporganname = node.parent.data.strorganname;
        data.lvid == '0' ? this.departForm.strtoporgancode = '' : this.departForm.strtoporgancode = node.parent.data.strorgancode;
        this.$nextTick(() => {
          this.$refs[`dep`].inputValue = this.departForm.strtoporganname;
        });
        this.departForm.lvlid = data.lvid;
        this.departForm.strLeaderid = data.strLeaderid;
        this.departForm.strtopLeaderid = data.strtopLeaderid;
        this.departForm.strHandleid = data.strHandleid;
        this.strHandleidList = data.strHandleid ? data.strHandleid.split(',') : [];
        this.departForm.strParIsbusiteam = data.strParIsbusiteam;
        this.departForm.strPartner = data.strPartner;
        this.departForm.strIsbusiteam = data.strIsbusiteam;
        this.departForm.strIsRecteam = data.strIsRecteam;
        this.departForm.strIsCustomerteam = data.strIsCustomerteam;
        this.departForm.strAffbusicost = data.strAffbusicost;
        this.showEditDepart = true;
        this.oldname = data.strorganname;
        this.oldHandleid = data.strHandleid;
        this.isadd = false;
        // console.log('sf', this.departForm);
      },
      cleardepart() {
        this.departForm = {
          strorgancode: '', //部门id
          strtoporgancode: '', //上级部门id
          strtoporganname: '',
          lvlid: '', //lv
          orderid: '1',
          strorganname: '', //部门名称
          strLeaderid: '', //负责人
          strtopLeaderid: '', //最高负责人
          strHandleid: '', //经办人
          strParIsbusiteam: '否',
          strPartner: '', //合伙人
          strIsbusiteam: '否',
          strIsRecteam: '否',
          strIsCustomerteam: '否',
        }
      },
      confirm() {
        console.log(this.departForm)
        this.$refs['departForm'].validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            if (this.strHandleidList.length > 0) {
              this.departForm.strHandleid = this.strHandleidList.toString();
            } else {
              this.departForm.strHandleid = '';
            }
            const switchMap = {
              strParIsbusiteam: this.departForm.strParIsbusiteam,
              strIsbusiteam: this.departForm.strIsbusiteam,
              strIsRecteam: this.departForm.strIsRecteam,
              strIsCustomerteam: this.departForm.strIsCustomerteam,
              strAffbusicost:this.departForm.strAffbusicost
            };
            Object.keys(switchMap).forEach(key => {
              this.departForm[key] = switchMap[key] === '是';
            });
            xz.rcFun(this.departForm, 'OrganizationalStructure/SetOrganizationalSave').then(res => {
              if (res.status == 'ok') {
                this.isBtnLoading = false;
                this.$message.success('保存成功');
                this.getDepartTree(this.departForm.strorgancode ? this.departForm.strorgancode : this.departForm.strtoporgancode);
                // this.isadd ? this.departInfo = this.info : this.departInfo = this.departForm;
                this.departInfo = this.isadd ? this.info : this.departForm
                this.showEditDepart = false;
                if (this.oldHandleid != this.departForm.strHandleid) {
                  if (this.oldHandleid) {
                    let data = {
                      userid: this.oldHandleid
                    }
                    this.nonertndataquery(data)
                  }
                  if (this.departForm.strHandleid) {
                    let data = {
                      userid: this.departForm.strHandleid
                    }
                    this.nonertndataquery(data)
                  }
                }
              } else {
                this.isBtnLoading = false;
                this.$message.warning(res.msg)
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      nonertndataquery(data) {
        xz.nonertndataquery(data).then(res => {
          if (res.status == 'ok') {

          } else {
            this.$message.error('用户权限更新出错')
          }
        })
      },
      banDepart(data) {
        this.info = data;
        this.isdelete = false;
        if (data.strIsDisable == '1') {
          this.disableOrganInfoById('0')
        } else {
          this.visibleDel = true;
        }
      },
      deleteDepart(data) {
        this.isdelete = true;
        this.info = data;
        this.visibleDel = true;
      },
      //删除/禁用部门
      confirmDeleteDepart() {
        if (this.isdelete) {
          xz.delOrganInfoById(this.info.strorgancode).then(res => {
            if (res.status == 'ok') {
              this.getDepartTree(this.info.strtoporgancode);
              this.$message.success(res.msg);
              this.visibleDel = false;
            } else {
              this.$message.error('系统出错');
              this.visibleDel = false;
            }
          })
        } else {
          this.disableOrganInfoById('1')
        }
      },
      disableOrganInfoById(strIsDisable) {
        xz.disableOrganInfoById(this.info.strorgancode, strIsDisable).then(res => {
          if (res.status == 'ok') {
            this.getDepartTree(this.info.strorgancode);
            this.$message.success(res.msg);
            this.getnobandetree();
            this.visibleDel = false;
          } else {
            this.$message.error('系统出错')
          }
        })
      },
      //导出人员
      exportMember() {
        let data = {
          keyword: '',
          strWorkState: this.strWorkState,
          currpage: 1,
          perpage: 1000000
        }
        this.btnLoading = true;
        this.export('getauthOutUserLists', data)
      },
      //导出机构
      exportOrg() {
        let data = {
          keyword: '',
          roletype: this.role,
          currpage: 1,
          perpage: 1000000
        }
        this.btnLoading2 = true;
        this.export('getOutOrganLists', data)
      },
      handleCommand(command) {
        if (command == 'a') {
          this.exportMember();
        } else {
          this.exportOrg();
        }
      },
      export (pagename, data) {
        xz.getOutUserLists(pagename, data).then(res => {
          if (res.status == 'ok') {
            this.$router.push({
              path: "/sysexport",
              query: {
                showPage: 1,
                isActive: 1,
                custname: res.msg,
                radio2: pagename == 'getauthOutUserLists' ? '人员导出' : '机构导出',
                //qStstus=1时查看最后一条导出记录
                qStstus: 1
              }
            })
          } else {
            this.$message({
              message: "导出失败，请稍后再试",
              type: "error"
            })
          }
          pagename == 'getauthOutUserLists' ? this.btnLoading = false : this.btnLoading2 = false;
        })
      },
      handleSectionChange(value) {
        let dep = this.$refs.dep.panel.getNodeByValue(value);
        if (dep != undefined) {
          this.departForm.strtoporganname = dep.data.strorganname;
          this.departForm.strtoporgancode = dep.data.strorgancode;
          this.departForm.lvlid = Number(dep.data.lvid) + 1;
        }
        this.$refs.dep._data.dropDownVisible = false;
      },
    }
  };
</script>
<style scoped>
  .dep_label_box {
    padding: 10px 0;
    max-height: 500px;
    overflow-y: auto;
  }

  .tag_btn_box {
    display: flex;
    justify-content: flex-end;
    padding: 0;
    margin-bottom: 10px;
  }

  .memberComn {
    padding-bottom: 0;
  }

  .memberTable {
    /* max-width: 89%; */
    min-width: 200px;
    margin-left: 16px;
    box-sizing: border-box;
    overflow: hidden;
  }

  .reset {
    height: 32px;
    padding: 5px 15px;
    border-radius: 5px;
    color: #b2bcb7;
    background-color: #fff;
    border: 1px solid #fff;
    margin-right: 10px;
  }

  .departTree_btn {
    margin-left: 5px;
  }

  .level_item {
    font-size: 14px;
  }

  .departInfo {
    width: calc(100% - 40px);
    padding: 20px;
    background: #fff;
    font-size: 14px !important;
    border-top: 1px solid #e4e7ed;
  }

  .addnewdepart {
    width: 108px;
    text-align: right;
    color: #19bd92;
  }

  .addLv {
    margin: 5px 0 10px 10px;
    font-size: 14px;
    color: #409eff;
  }

  .departTree {
    /* width: 220px; */
    margin: 16px 0 0 12px;
    overflow: auto;
    position: relative;
    float: left;
    background-color: #fff;
  }

  .resize-save {
    position: absolute;
    top: 0;
    right: 5px;
    bottom: 0;
    left: 0;
    padding: 16px;
    overflow-x: hidden;
  }

  .resize-bar {
    width: 260px;
    min-height: 600px;
    min-width: 40px;
    resize: horizontal;
    /* cursor: ew-resize; */
    /* cursor: col-resize; */
    opacity: 0;
    overflow: scroll;
  }

  /* 拖拽线 */
  .resize-line {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    pointer-events: none;
  }

  .resize-bar:hover~.resize-line,
  .resize-bar:active~.resize-line {
    border-left: 1px dashed skyblue;
  }

  .resize-bar::-webkit-scrollbar {
    width: 260px;
    min-height: 600px;
  }

  .choosename {
    color: #19bd92;
    font-size: 14px;
  }

  .switchBox {
    width: 220px;
  }
</style>

<style>
  /* 直接设置横轴内容滚动条 即可撑高高度 还不影响使用 */
  .p_depart_member .el-table .el-table__body-wrapper {
    overflow-x: scroll;
  }

  .p_depart_member .el-table .el-table__cell {
    padding: 3px 0;
  }

  .p_depart_member .el-table__row.current-row .choosename {
    color: #fff !important;
  }

  .mem_btn .search {
    height: 32px;
    padding: 0 15px;
    margin-right: 10px;
    border-radius: 5px;
    background-color: #ebfaf5;
    border: 1px solid #62d2b4;
    color: #19BD92;
  }

  .addmember .el-date-editor.el-input,
  .addmember .el-date-editor.el-input__inner {
    width: 206px;
  }

  .mulDepart .el-input {
    width: 206px;
  }

  .el-dialog .el-dialog__header {
    background: #fff;
  }

  .clear {
    color: #76a196;
  }

  .el-dialog__title {
    font-size: 20px;
    color: #000;
  }

  .departTree .el-input__inner {
    height: 36px;
    line-height: 36px;
    margin-bottom: 10px;
  }

  .departTree_btn i {
    font-size: 16px;
    /* margin-left: 5px; */
  }

  .departTree_btn i.el-icon-plus {
    color: rgb(237, 175, 84);
  }

  .departTree_btn i.el-icon-edit {
    color: #409eff;
  }

  .departTree_btn i.el-icon-delete {
    color: #f56c6c;
  }

  .departTree_btn i.el-icon-circle-close {
    color: #f56c6c;
  }

  .departTree_btn i.el-icon-circle-check {
    color: #67c23a;
  }

  .memberTable .crumbs {
    width: 100%;
    background-color: #fff;
  }

  .memberTable .el-tabs__header {
    position: static;
    margin: 1px 0 0 0;
  }

  .departTree .custom-tree-node {
    width: 240px;
  }

  .departMemberTop .el-input__inner {
    height: 36px;
  }

  .departMemberTop .el-button--success.is-plain {
    padding: 11px 15px;
  }

  .departMemberTop .search {
    height: 36px;
  }

  .departInfo .el-cascader-node.in-active-path,
  .el-cascader-node.is-active,
  .el-cascader-node.is-selectable.in-checked-path {
    color: #19bd92 !important;
  }

  .departInfo .el-cascader .el-input .el-input__inner:focus,
  .el-cascader .el-input.is-focus .el-input__inner {
    color: #19bd92 !important;
  }

  .mulDepart .el-button {
    padding: 12px;
  }

  .addmember .el-input--suffix .el-input__inner {
    padding-right: 15px;
  }

  .dialog-box .el-switch.is-checked .el-switch__core {
    border-color: #19bd92;
    background-color: #19bd92;
  }

  .departInfo .el-descriptions-item__container {
    font-size: 14px !important;
  }

  .diaform .el-select {
    width: 100%;
  }

  .frozenform .el-input--prefix .el-input__inner {
    width: 233px;
  }

  /* .memberTable .el-table__body tr.current-row > td.el-table__cell {
  background: #d2dcf8;
} */
  .departMemberTop .el-input__icon {
    line-height: 36px;
  }

  input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }

  input::-webkit-outer-spin-button {
    -webkit-appearance: none !important;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }

  /*滚动条样式*/
  .resize-save::-webkit-scrollbar {
    width: 4px;
  }

  .resize-save::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .resize-save::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);

  }
</style>